import { getCsrfToken } from '@/integrations/php/client';

export interface AdminPartnerSmsLog {
  id: string;
  type: 'send' | 'click';
  messageId: string | null;
  status: string;
  leadId: string | null;
  leadName: string;
  leadPhone: string;
  timestamp: string | null;
}

export interface AdminPartnerEmailLog {
  id: string;
  trackingId: string | null;
  leadId: string | null;
  email: string;
  event: string;
  timestamp: string | null;
}

const nullableString = (value: unknown): string | null =>
  value === null || value === undefined || value === '' ? null : String(value);

const requestRows = async (url: string): Promise<Array<Record<string, unknown>>> => {
  const response = await fetch(url, {
    credentials: 'include',
    headers: { 'X-CSRF-Token': await getCsrfToken() },
  });
  const body = await response.json().catch(() => []);
  if (!response.ok) throw new Error('Δεν φορτώθηκε το ιστορικό επικοινωνίας.');
  return Array.isArray(body) ? body : [];
};

export async function fetchAdminPartnerSmsLogs(partnerId: string): Promise<AdminPartnerSmsLog[]> {
  const params = new URLSearchParams({ partnerId, limit: '2000' });
  const rows = await requestRows(`/api/get-sms-logs.php?${params}`);
  return rows.map((row) => ({
    id: String(row.id || ''),
    type: row.type === 'click' ? 'click' : 'send',
    messageId: nullableString(row.messageId ?? row.message_id),
    status: String(row.status || row.event || ''),
    leadId: nullableString(row.leadId ?? row.lead_id),
    leadName: String(row.leadName ?? row.lead_name ?? ''),
    leadPhone: String(row.leadPhone ?? row.lead_phone ?? ''),
    timestamp: nullableString(row.timestamp ?? row.created_at),
  }));
}

export async function fetchAdminPartnerEmailLogs(partnerId: string): Promise<AdminPartnerEmailLog[]> {
  const params = new URLSearchParams({ partnerId, limit: '2000' });
  const rows = await requestRows(`/api/get-email-logs.php?${params}`);
  return rows.map((row) => ({
    id: String(row.id || ''),
    trackingId: nullableString(row.trackingId ?? row.tracking_id),
    leadId: nullableString(row.leadId ?? row.lead_id),
    email: String(row.email || ''),
    event: String(row.event || ''),
    timestamp: nullableString(row.timestamp ?? row.created_at),
  }));
}
